import packageJson from '../package.json';

/** 브라우저 탭·PWA·로고 접근성 등에 쓰는 앱 표시 이름 */
export const APP_DISPLAY_NAME = '클래스 플래너';

/** 네비·UI에 표시하는 앱 버전 (`package.json`과 동일) */
export const APP_VERSION: string =
  typeof packageJson.version === 'string' && packageJson.version.trim()
    ? packageJson.version.trim()
    : '1.2.193';

/** 나이스 시간표 도우미 Chrome 웹 스토어 주소 — 등록 전에는 빈 문자열(웹앱에 설치 안내가 뜸) */
export const NEIS_EXTENSION_STORE_URL = '';

/** '나이스 열기' 기본 주소(도우미가 마지막 지역 나이스 주소를 모를 때) */
export const NEIS_DEFAULT_URL = 'https://www.neis.go.kr/';
